import { BlobReader, TextReader, Uint8ArrayReader, Uint8ArrayWriter, ZipWriter, } from '@zip.js/zip.js';
import { toIumSourceToPath } from './transformation/source_zip.js';
/**
 * This method will zip a file collection and return the zip as an ArrayBuffer
 * @param fileCollection - The file collection to zip
 * @param options - Options for the zip process
 * @returns Zip as an Uint8Array
 */
export async function toIum(fileCollection, options = {}) {
    const { includeData = true, getExtraFiles } = options;
    const zipWriter = new ZipWriter(new Uint8ArrayWriter());
    const sources = [];
    const promises = [];
    for (const source of fileCollection.sources) {
        const newSource = {
            relativePath: source.relativePath,
            baseURL: source.baseURL,
            lastModified: source.lastModified,
            size: source.size,
            extra: source.extra,
        };
        sources.push(newSource);
        const shouldIncludeFile = includeData || source.baseURL === 'ium:/';
        if (!shouldIncludeFile)
            continue;
        newSource.baseURL = 'ium:/';
        const pathname = toIumSourceToPath(newSource);
        promises.push(zipWriter.add(pathname, source.stream()).then(() => void 0));
    }
    await Promise.all(promises);
    const index = {
        options: fileCollection.options,
        sources,
    };
    if (getExtraFiles) {
        await Promise.all(map(getExtraFiles(structuredClone(index), fileCollection), async (extraFile) => {
            const { relativePath, data } = extraFile;
            const url = new URL(relativePath, 'ium:/');
            sources.push({
                extra: true,
                baseURL: 'ium:/',
                relativePath,
            });
            await zipWriter.add(url.pathname, getExtraFileContentReader(data));
        }));
    }
    const url = new URL('index.json', 'ium:/');
    await zipWriter.add(url.pathname, new TextReader(JSON.stringify(index, null, 2)));
    return await zipWriter.close();
}
export const UNSUPPORTED_EXTRA_FILE_CONTENT_ERROR = `Unsupported file content type.
If you passed a Node.js Stream convert it to Web Stream.`;
function getExtraFileContentReader(fileContent) {
    if (typeof fileContent === 'string') {
        return new TextReader(fileContent);
    }
    else if (fileContent instanceof Uint8Array) {
        // support Node.js Buffer they extend Uint8Array,
        // but when it is read by Uint8ArrayReader it produces `Error: Split zip file`
        // wrap Node.js Buffer into a new Uint8Array fix the issue
        return new Uint8ArrayReader(new Uint8Array(fileContent.buffer, fileContent.byteOffset, fileContent.length));
    }
    else if (fileContent instanceof ArrayBuffer) {
        return new Uint8ArrayReader(new Uint8Array(fileContent));
    }
    else if (fileContent instanceof Blob) {
        return new BlobReader(fileContent);
    }
    else if (fileContent instanceof ReadableStream) {
        return fileContent;
    }
    throw new Error(UNSUPPORTED_EXTRA_FILE_CONTENT_ERROR);
}
function* map(items, mapFn) {
    for (const item of items) {
        yield mapFn(item);
    }
}
//# sourceMappingURL=toIum.js.map